import { render, staticRenderFns } from "./PanelAccounts.vue?vue&type=template&id=bc76867e&lang=pug&"
import script from "./PanelAccounts.vue?vue&type=script&lang=js&"
export * from "./PanelAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports